import { render } from "./ColoredLinksPage.vue?vue&type=template&id=76c84706&ts=true"
import script from "./ColoredLinksPage.vue?vue&type=script&lang=ts"
export * from "./ColoredLinksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__